import { Loader2 } from "lucide-react";
import { CATEGORIES } from "@/lib/api";
import { Field, inputCls, selectCls } from "@/components/FormField";

const CONDITIONS = [["new", "New"], ["used", "Used"], ["refurbished", "Refurbished"]];

export function BasicInfoFields({ form, set }) {
  return (
    <>
      <Field label="Title" required>
        <input data-testid="form-title" required value={form.title} onChange={set("title")} className={inputCls} />
      </Field>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Field label="Category" required>
          <select data-testid="form-category" value={form.category} onChange={set("category")} className={selectCls}>
            {CATEGORIES.map((c) => <option key={c.slug} value={c.slug}>{c.name}</option>)}
          </select>
        </Field>
        <Field label="Condition">
          <select data-testid="form-condition" value={form.condition} onChange={set("condition")} className={selectCls}>
            {CONDITIONS.map(([v, label]) => <option key={v} value={v}>{label}</option>)}
          </select>
        </Field>
      </div>
    </>
  );
}

export function PriceLocationFields({ form, set }) {
  const isJob = form.category === "jobs";
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Field label={isJob ? "Compensation (optional)" : "Price"} required={!isJob}>
        <div className="flex">
          <select data-testid="form-currency" value={form.currency} onChange={set("currency")} className="border-2 border-black border-r-0 px-2 py-2 font-mono-data bg-white rounded-none text-sm">
            <option value="USD">USD $</option>
            <option value="CAD">CAD CA$</option>
          </select>
          <input data-testid="form-price" type="number" required={!isJob} min="0" step="0.01" value={form.price} onChange={set("price")} placeholder={isJob ? "Leave blank to show 'See description'" : ""} className={`${inputCls} flex-1`} />
        </div>
      </Field>
      <Field label="Location" required>
        <input data-testid="form-location" required value={form.location} onChange={set("location")} placeholder="City, State/Province" className={inputCls} />
      </Field>
    </div>
  );
}

export function DescriptionField({ form, set }) {
  return (
    <Field label="Description" required>
      <textarea data-testid="form-description" required rows={6} value={form.description} onChange={set("description")} className={inputCls} />
    </Field>
  );
}

export function ContactFields({ form, set }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Field label="Contact Email">
        <input data-testid="form-email" type="email" value={form.contact_email} onChange={set("contact_email")} className={inputCls} />
      </Field>
      <Field label="Contact Phone">
        <input data-testid="form-phone" value={form.contact_phone} onChange={set("contact_phone")} className={inputCls} />
      </Field>
    </div>
  );
}

export function FormActions({ submitting, isEdit, onCancel }) {
  return (
    <div className="flex gap-3 pt-4 border-t-2 border-black">
      <button data-testid="form-submit" type="submit" disabled={submitting} className="bg-[#0000EE] text-white px-6 py-3 border-2 border-[#0000EE] font-mono-data uppercase text-sm hover:bg-[#0000AA] hover:border-[#0000AA] disabled:opacity-50 flex items-center gap-2">
        {submitting && <Loader2 className="animate-spin" size={14} />}
        {isEdit ? "Save Changes" : "Post Ad"}
      </button>
      <button type="button" onClick={onCancel} className="bg-white text-black px-6 py-3 border-2 border-black font-mono-data uppercase text-sm hover:bg-gray-100">Cancel</button>
    </div>
  );
}
